import { setupApmInit } from "@/arad/apm/init";
import runner from "./app-runner";

// Initialize APM as early as possible — before any async bootstrap work —
// so the page-load transaction captures accurate timing.
setupApmInit();

void runner();

